import { HttpClient } from '@angular/common/http';
import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginScreenDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/login-screen-dialog/login-screen-dialog.component';
import { ScreenType } from 'src/app/enums/ScreenType';
import { UserRegDetails, initUserRegDetails } from 'src/app/models/user';
import { AumyeSecurityPassService } from 'src/app/services/aumye-security-pass.service';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';
import {
  passwordMatchValidator,
  patternValidator,
} from 'src/app/utils/password-util';
import { environment } from 'src/app/environments/environments';
@Component({
  selector: 'app-user-additional-details',
  templateUrl: './user-additional-details.component.html',
  styleUrls: ['./user-additional-details.component.scss'],
})
export class UserAdditionalDetailsComponent implements OnInit {
  userId: string;
  qrData = '';
  isDataFilled = true;
  userData: UserRegDetails = initUserRegDetails;
  urlProfile: any;
  urlID: any;
  hide = true;
  hideCnf = true;
  isAllDetailsFilled = false;
  urlProfileFile: any;
  urlIdFile: any;
  showMsg = false;
  isRetry = false;
  isShowMsg = false;
  isFaceMatched = false;
  error = '';
  isAPIRequest = false;
  screenSize: ScreenType;
  baseServerURL = environment.apiUrl;
  constructor(
    private activeRoute: ActivatedRoute,
    private formbuilder: FormBuilder,
    private httpclient: HttpClient,
    private router: Router,
    private dialog: MatDialog,
    private screen: AumyeResponsiveScreenService
  ) {
    this.screen.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });
    this.activeRoute.queryParams.subscribe((params) => {
      this.userId = params['id'];
    });
    this.qrData = window.location.href;
  }
  firstFormGroup = this.formbuilder.group({
    firstCtrl: ['', Validators.required],
  });
  secondFormGroup = this.formbuilder.group({
    secondCtrl: ['', Validators.required],
  });
  isEditable = false;
  offsetFlag = true;
  userFaceIdForm = this.formbuilder.group({
    photoID: ['', [Validators.required]],
    profilePic: ['', [Validators.required]],
  });
  userDetailsPass = this.formbuilder.group({
    orgID: ['', [Validators.required]],
    // orgName: ['', [Validators.required]],
    userId: ['', [Validators.required]],
    userName: [''],
    firstname: ['', [Validators.required]],
    lastname: ['', [Validators.required]],
    email: ['', [Validators.required]],
    phone: ['', [Validators.required]],
    role: ['', [Validators.required]],
    address: ['', [Validators.required]],
    gender: ['', [Validators.required]],
    status: ['', [Validators.required]],
    dateOfBirth: ['', [Validators.required]],
  });
  createPwdFormGroup = this.formbuilder.group(
    {
      password: [
        '',
        [
          Validators.required,
          patternValidator(/\d/, {
            hasNumber: true,
          }),
          patternValidator(/[A-Z]/, {
            hasCapitalCase: true,
          }),
          patternValidator(/[a-z]/, {
            hasSmallCase: true,
          }),
          patternValidator(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/, {
            hasSpecialCharacters: true,
          }),
          Validators.minLength(8),
        ],
      ],
      confirmPassword: ['', [Validators.required]],
    },
    {
      validator: passwordMatchValidator,
    }
  );
  ngOnInit(): void {
    let baseServerURL = this.baseServerURL + 'GetUserDetails?id=' + this.userId;
    this.httpclient.get(baseServerURL).subscribe((res: any) => {
      this.userData = res;
      // this.openLoginPopUp();
      this.setUserDetailForm(this.userData);
    });
  }
  setUserDetailForm(val: UserRegDetails) {
    this.urlID = val.identityID;
    this.urlProfile = val.profilePicture;
    if (val.profilePicture) {
      this.isRetry = true;
    }
    this.userDetailsPass.controls.firstname.setValue(val.firstname);
    this.userDetailsPass.controls.lastname.setValue(val.lastname);
    this.userDetailsPass.controls.orgID.setValue(val.orgID);
    this.userDetailsPass.controls.userId.setValue(val.userId);
    this.userDetailsPass.controls.email.setValue(val.email);
    this.userDetailsPass.controls.phone.setValue(val.phoneNumber);
    this.userDetailsPass.controls.address.setValue(val.userAddress);
    this.userDetailsPass.controls.role.setValue(val.userRole);
    this.userDetailsPass.controls.gender.setValue(val.gender);
    this.userDetailsPass.controls.userName.setValue(val.userName);
    this.userDetailsPass.controls.status.setValue(
      val.userStatus == 0 ? 'Unverified' : 'Verified'
    );
    this.userDetailsPass.controls.dateOfBirth.setValue(
      new Date(val.dateOfBirth).toISOString().slice(0, -1)
    );
  }
  onSubmitUserDetail() {
    console.log(this.userDetailsPass.value);
  }
  onUploadProfile(event: any) {
    this.urlProfileFile = event.target.files[0];
    if (event.target.files[0]) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (event: any) => {
        this.urlProfile = event.target.result;
        this.userFaceIdForm.value.profilePic = this.urlProfile;
      };
    }
  }
  onUploadID(event: any) {
    this.urlIdFile = event.target.files[0];
    if (event.target.files[0]) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (event: any) => {
        this.urlID = event.target.result;
        this.userFaceIdForm.value.photoID = this.urlID;
      };
    }
  }
  inputValidator(event: { charCode: number }) {
    return event.charCode != 32;
  }
  faceMatchMsg = '';
  onClickVerify(stepper: MatStepper) {
    this.isAPIRequest = true;
    let baseServerURL =
      this.baseServerURL + 'FaceRecognition?UserID=' + this.userId;
    const formData = new FormData();
    formData.append('File', this.urlIdFile, this.urlIdFile.name);
    formData.append('Photo', this.urlProfileFile, this.urlProfileFile.file);
    formData.append('Name', this.userData.firstname);
    formData.append('Orgid', this.userData.orgID);
    this.httpclient
      .post(baseServerURL, formData, { responseType: 'text' })
      .subscribe(
        (res) => {
          this.showMsg = true;
          this.faceMatchMsg = res;
          this.isAPIRequest = false;
          this.isFaceMatched = true;
          this.isRetry = false;
          this.error = '';
          this.userDetailsPass.controls.status.setValue('Verified');
          setTimeout(() => {
            stepper.next();
          }, 1500);
        },
        (err) => {
          this.error = 'Error: Please try again!';
          this.showMsg = true;
          this.isAPIRequest = false;
          this.isRetry = true;
          this.isFaceMatched = false;
          this.faceMatchMsg = err.error
            ? err.error
            : 'Error: Please try again!';
          this.userDetailsPass.controls.status.setValue('Unverified');
        }
      );
  }
  onSaveUserDetails(stepper: MatStepper) {
    stepper.next();
    let baseServerURL = this.baseServerURL + 'UpdateUserDetails';
    this.httpclient
      .post(baseServerURL, this.userDetailsPass.value, { responseType: 'text' })
      .subscribe(
        (res) => {
          this.isShowMsg = true;
          if (res === 'success') {
            this.error = 'Details Saved! Redirecting to login!';
            setTimeout(() => {
              this.router.navigateByUrl('authentication/login');
              // window.location.reload();
            }, 1500);
          } else this.error = 'Please try again!';
        },
        (err) => {
          this.error = 'Error: Please try again!';
          this.isShowMsg = true;
          this.isAPIRequest = false;
        }
      );
  }
  openLoginPopUp() {
    let isUserLoggedIn = localStorage.getItem('UserId');
    if (!isUserLoggedIn) {
      const dialogRef = this.dialog.open(LoginScreenDialogComponent, {
        disableClose: false,
        data: this.userData,
      });
    }
  }
  // onClickVerify() {
  //   const formData = new FormData();
  //   formData.append('File', this.urlIdFile, this.urlIdFile.name);
  //   formData.append('photo', this.urlProfileFile, this.urlProfileFile.file);
  //   this.securityPassService.verifyUserIdentity(formData).subscribe((res) => {
  //     window.alert(res);
  //   });
  // }
  ScreenType = ScreenType;
}
